import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess?: () => void
  children?: () => ReactElement
}

const DeleteModelerScriptTestCaseRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases/scripted/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteModelerScriptTestCaseRequest
